export default "__VITE_ASSET__Cr2WIHvm__"